import { put } from 'redux-saga/effects';

import * as endpoint from 'misc/endpoint';
import * as types from 'misc/types';
import { getText, getBankIdPopupData, trackGA } from 'misc/helpers';
import { popup_icon_type } from 'components/shared/popup/Popup';

export const GOVERNMENT_STATUS = Object.freeze({
    NOT_REGISTERED: 1,
    REGISTERED: 2,
    REGISTERED_OTHER: 3
});

export function* getGovernmentConnect(action) {
    try {
        const response = yield endpoint.get('governmentstatus');

        yield put({ type: types.SAGA_GOVERNMENT_CONNECT_GET.SUCCESS, payload: response.data });

        if (response.data.type === GOVERNMENT_STATUS.REGISTERED) {
            trackGA('10.2 Avsändare');
            yield put({ type: types.SAGA_GOVERNMENT_LIST_GET.REQUEST });
        } else {
            trackGA('10.0 Anslut myndighetspost');
        }
    } catch (error) {
        yield put({ type: types.SAGA_GOVERNMENT_CONNECT_GET.FAILURE, error });
    }
}

export function* postGovernmentConnect(action) {
    let success = false;

    try {
        // Show Bank ID popup
        yield put(getBankIdPopupData(types.SAGA_GOVERNMENT_CONNECT_POST, getText('Missing', 'Användare avbröt anslutning')));

        // Api call
        const response = yield endpoint.post('far', action.payload);

        if (response.status === 202) {
            // Start bank id authentication
            let bankid_response = yield endpoint.location(response.data.signatureUrl);

            if (bankid_response.status === 200) {
                success = true;
            }
        } else if (response.status === 200) {
            // Automatic approval if demo account
            success = true;
        }
    } catch (error) {
        yield put({ type: types.SAGA_GOVERNMENT_CONNECT_POST.FAILURE, error });
    }

    if (success) {
        // Hide popup
        yield put({ type: types.SAGA_GOVERNMENT_CONNECT_POST.SUCCESS, payload: action.response });
        yield put({ type: types.POPUP_HIDE });

        yield put({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.success,
                header: '',
                text: getText('_10_1_Text_confirm_sign', 'Du är nu ansluten!')
            }
        });

        trackGA('10.1 Du är nu ansluten');

        // Fetch list
        yield put({ type: types.SAGA_GOVERNMENT_CONNECT_GET.REQUEST });
    } else {
        yield put({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.error,
                header: '',
                text: getText('Missing', 'Ett fel uppstod')
            }
        });
    }
}

export function* deleteGovernmentConnect(action) {
    trackGA('10.4 Avsluta myndighetspost');

    let success = false;

    try {
        // Show Bank ID popup
        yield put(getBankIdPopupData(types.SAGA_GOVERNMENT_CONNECT_DELETE, getText('Missing', 'Användare avbröt avslut')));

        // Api call
        const response = yield endpoint.remove('far', action.payload);

        if (response.status === 202) {
            // Start bank id authentication
            let bankid_response = yield endpoint.location(response.data.signatureUrl);

            if (bankid_response.status === 200) {
                success = true;
            }
        } else if (response.status === 200) {
            // Automatic approval if demo account
            success = true;
        }
    } catch (error) {
        yield put({ type: types.SAGA_GOVERNMENT_CONNECT_DELETE.FAILURE, error });

        yield put({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.error,
                header: '',
                text: error.message
            }
        });
    }

    if (success) {
        trackGA('10.5 Ej ansluten');

        // Hide popup
        yield put({ type: types.SAGA_GOVERNMENT_CONNECT_DELETE.SUCCESS, payload: action.response });
        yield put({ type: types.POPUP_HIDE });

        // Show disconnect confirm
        yield put({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.success,
                header: getText('_10_5_Titel_authority_exit', 'Myndighetspost avslutad!'),
                text: getText(
                    '_10_5_text_authority_exit',
                    'Du kommer inte längre få din post från myndigheter och kommuner skickat till din Digimail. Vill du ansluta på nytt, kan du göra detta under inställningar. '
                )
            }
        });
    }
}

export function* getGovernmentList(action) {
    try {
        const response = yield endpoint.get('addresses?type=1');

        // Add key to array items so warnings in browser dissappear
        response.data.forEach(function(government) {
            government.key = government.id;
        });

        yield put({ type: types.SAGA_GOVERNMENT_LIST_GET.SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.SAGA_GOVERNMENT_LIST_GET.FAILURE, error });
    }
}

export function* putGovernmentList(action) {
    let success = false;

    // Show Bank ID popup
    yield put(getBankIdPopupData(types.SAGA_GOVERNMENT_LIST_PUT, getText('Missing', 'Användare avbröt uppdatering')));

    try {
        // Create data array to send to api
        let listToSend = [];
        action.checkboxes.forEach(function(government) {
            listToSend.push({
                id: government.id,
                active: government.active
            });
        });

        // Api call
        const response = yield endpoint.put('addresses?type=1', listToSend);

        if (response.status === 202) {
            // Start bank id authentication
            let bankid_response = yield endpoint.location(response.data.signatureUrl);

            if (bankid_response.status === 200) {
                success = true;
            }
        } else if (response.status === 200) {
            // Automatic approval if demo account
            success = true;
        }
    } catch (error) {
        yield put({ type: types.SAGA_GOVERNMENT_LIST_PUT.FAILURE, error });
    }

    // Show popup message if success or failure
    if (success) {
        trackGA('10.3 Inställningar sparade');

        yield put({ type: types.SAGA_GOVERNMENT_LIST_PUT.SUCCESS, payload: action.checkboxes });
        yield put({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.success,
                header: '',
                text: getText('_12_1_TitelDataSaved', 'Dina inställningar är sparade!')
            }
        });
    } else {
        yield put({ type: types.SAGA_GOVERNMENT_LIST_PUT.FAILURE, payload: action.checkboxes });
        yield put({ type: types.POPUP_HIDE });
    }
}



// WEBPACK FOOTER //
// ./src/sagas/government.js